import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { Team, User } from '~/monolith-api';

export type ApprovalStage = {
   stageid: number;
   name: string;
   user: User;
   team: Team;
   approval_process_stageid: number;
};

export type ApprovalProcessListItem = {
   approval_processid: number;
   name: string;
   stages: ApprovalStage[];
};

export type ApprovalProcessesResponse = ApprovalProcessListItem[];

export async function getApprovalProcesses(
   searchTerm: string | null,
   { ...common }: CommonRequestOptions = {}
): Promise<ApprovalProcessesResponse> {
   if (searchTerm) {
      const { results } = await makeRequest('get', `/approvals/process/search/${searchTerm}`, {
         ...common,
      });
      return results;
   }
   return makeRequest('get', `/approvals/processes`, {
      ...common,
   });
}
